module.exports = __webpack_public_path__ + "assets/img/end-btn.6b61aba3.png";